import type { Configuration } from './public-form.ts'

export type FormMutation = { action: 'save' | 'publish'; draft: Configuration } | { action: 'unpublish' }

// A response must only clear the exact draft that was submitted.
export function draftAfterMutation(current: Configuration | undefined, input: FormMutation) {
    if (input.action === 'unpublish') return current
    return current === input.draft ? undefined : current
}
